<template>
  <drag-dialog
    title="场景名称"
    :width="500"
    :visible.sync="visible"
    :defaultTop="320"
    :defaultLeft="700"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel"
  >
    <el-form
      :model="form"
      class="form"
      label-width="100px"
      :rules="rules"
      ref="form"
    >
      <el-form-item class="form-item" label="场景名称:" prop="sceneName">
        <el-input
          :maxlength="100"
          show-word-limit
          v-model="form.sceneName"
          placeholder="请输入场景名称"
        ></el-input>
      </el-form-item>
    </el-form>
  </drag-dialog>
</template>
    
<script>
import dragDialog from "@/components/DragDialog.vue";
export default {
  data() {
    return {
      disabled: false,
      form: {
        sceneName: "",
      },
      rules: {
        sceneName: [
          {
            required: true,
            message: "请输入场景名称",
            trigger: "blur",
          },
          {
            pattern: /^\S*$/g,
            message: "禁止输入空格",
            trigger: "change",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    copyParams: Object,
    submitModify: Function,
    closeDialog: Function,
  },
  components: {
    dragDialog,
  },
  mounted() {
    this.form.sceneName = this.copyParams.sceneName;
  },
  methods: {
    submit() {
      if (this.form.sceneName.length > 100) {
        this.$message.warning("场景名称最多支持100个字符");
        return;
      }
      let startInterval = setInterval(() => {
        this.disabled = false;
        clearInterval(startInterval);
      }, 60000);

      if (!this.disabled) {
        this.$refs.form.validate((bool, object) => {
          if (bool) {
            let params = {
              sceneId: this.copyParams.sceneId,
              sceneName: this.form.sceneName,
            };
            this.submitModify(params).then(() => {
              this.disabled = false;
              this.clearForm();
              this.closeDialog();
            });
          } else {
            this.$message.error("表单验证失败，请正确填写相关内容后再重新提交");
            this.disabled = false;
          }
          this.disabled = true;
        });
      }
    },
    cancel() {
      this.clearForm();
      this.closeDialog();
    },
    clearForm() {
      this.form = {
        sceneName: "",
      };
    },
  },
};
</script>
    
<style lang="less" scoped>
.form {
  padding: 5px 0px;
  .form-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>